<template>
    <div>
        <span v-if="loading" class="loader">
            <img class="spinner" src="assets/ajax-spinner.gif" />
        </span>
        <button
            v-else
            :class="{
                'dismiss-all': true,
                notallowed: disabled
            }"
            @click="handleClick"
            v-b-tooltip.hover.top="{
                customClass: 'dismiss-all-notification-tooltip'
            }"
            :title="tooltip"
        >
            <span>
                {{ dismissLabel }}
            </span>
        </button>
    </div>
</template>

<script>
export default {
    props: {
        loading: {
            type: Boolean,
            default: false
        },
        tooltip: {
            type: String
        },
        disabled: {
            type: Boolean,
            default: false
        },
        checkedItems: {
            type: Array
        }
    },
    computed: {
        dismissLabel() {
            if (this.checkedItems.length > 0) {
                return `Dismiss selected (${this.checkedItems.length})`;
            }
            return "Dismiss all";
        }
    },
    methods: {
        handleClick() {
            if (this.disabled) {
                return;
            }
            this.$emit("click");
        }
    }
};
</script>

<style lang="scss" scoped>
.loader {
    padding-left: 10px;
}
button {
    background: transparent;
    border: none;
    outline: none;

    &.dismiss-all {
        span {
            margin-left: 5px;
        }
    }

    &.notallowed {
        color: gray;
        cursor: not-allowed;
    }
}
</style>
